export function formatEUR(n: number | null | undefined): string {
  if (n == null || isNaN(n as number)) return '—';
  const v = Math.round((n as number) * 100) / 100;
  const dec = Number.isInteger(v) ? 0 : 2;
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: dec, maximumFractionDigits: dec }).format(v);
}

export function formatDateFR(iso: string, opts?: Intl.DateTimeFormatOptions): string {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('fr-FR', opts ?? { day: '2-digit', month: 'short', year: 'numeric' });
  } catch { return iso; }
}

export function daysUntil(iso: string): number | null {
  if (!iso) return null;
  // Extract date-only part to avoid timezone shifts when iso contains a time/Z suffix
  let y: number, m: number, day: number;
  const isoMatch = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    y = +isoMatch[1]; m = +isoMatch[2]; day = +isoMatch[3];
  } else {
    const dmy = iso.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2,4})/);
    if (!dmy) return null;
    day = +dmy[1]; m = +dmy[2]; y = +dmy[3]; if (y < 100) y += 2000;
  }
  const target = new Date(y, m - 1, day);
  if (isNaN(target.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diff = Math.round((target.getTime() - today.getTime()) / 86400000);
  return diff;
}

export function jLabel(iso: string): string {
  const d = daysUntil(iso);
  if (d == null) return '';
  if (d === 0) return 'J';
  return d > 0 ? `J-${d}` : `J+${Math.abs(d)}`;
}

export function downloadJson(filename: string, data: unknown) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}
